import React, { useState, useEffect } from "react";
import PropertyCard from "./PropertyCard"; // Assuming you have a PropertyCard component
import axios from "axios";
import { ImSortAlphaAsc } from "react-icons/im";
import { ImSortAlphaDesc } from "react-icons/im";
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha";
import { useNavigate } from "react-router-dom";

const PropertyList = ({ filters }) => {
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [properties, setProperties] = useState([]);
  const [sortedItems, setSortedItems] = useState([...properties]);
  const [sortOrder, setSortOrder] = useState(0);
  const navigate = useNavigate();

  const handlePropertyClick = (property) => {
    // Navigate to the PropertyDetailedPage with the title in the URL, and the id passed as state
    navigate(`/PropertyDetails/${property.title}`, {
      state: { id: properties.propertyId },
    });
  };
  // Fetch all properties from API
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(
          "https://realo-realestate.com/api/api/Property/GetProperties"
        );
        // const response = await axios.get(
        //   "https://localhost:7230/api/Property/GetProperties"
        // );
        setProperties(response.data); // Set the fetched properties
        setFilteredProperties(response.data); // Initially show all properties before filtering
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };
    fetchProperties();
  }, []);

  //Sort Item Function
  const handleSort = () => {
    let newOrder;
    let newItems;

    if (sortOrder === 0) {
      newOrder = 1;
      newItems = [...filteredProperties].sort((a, b) =>
        String(a.propertyId).localeCompare(String(b.propertyId))
      );
    } else if (sortOrder === 1) {
      newOrder = 2;
      newItems = [...filteredProperties].sort((a, b) =>
        String(b.propertyId).localeCompare(String(a.propertyId))
      );
    } else {
      newOrder = 0;
      newItems = [...properties]; // Reset to original order
    }

    setSortOrder(newOrder);
    setFilteredProperties(newItems);
  };

  // Apply filters when they change
  useEffect(() => {
    let filteredData = properties;
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filteredData = filteredData.filter(
        (property) =>
          property.title.toLowerCase().includes(searchLower) ||
          (property.neighborhood &&
            property.neighborhood.toLowerCase().includes(searchLower)) ||
          (property.city && property.city.toLowerCase().includes(searchLower))
      );
    }
    // Apply filters only if they are provided
    if (filters.propertyType) {
      filteredData = filteredData.filter(
        (property) => property.propertyType === filters.propertyType
      );
    }

    if (filters.minPrice) {
      filteredData = filteredData.filter(
        (property) => property.price >= parseInt(filters.minPrice)
      );
    }

    if (filters.maxPrice) {
      filteredData = filteredData.filter(
        (property) => property.price <= parseInt(filters.maxPrice)
      );
    }

    if (filters.bedrooms) {
      filteredData = filteredData.filter(
        (property) => property.bedrooms === parseInt(filters.bedrooms)
      );
    }

    if (filters.bathrooms) {
      filteredData = filteredData.filter(
        (property) => property.bathrooms === parseInt(filters.bathrooms)
      );
    }

    if (filters.minArea) {
      filteredData = filteredData.filter(
        (property) => property.squareFeet >= parseInt(filters.minArea)
      );
    }

    if (filters.maxArea) {
      filteredData = filteredData.filter(
        (property) => property.squareFeet <= parseInt(filters.maxArea)
      );
    }

    if (filters.isForSale !== null) {
      filteredData = filteredData.filter(
        (property) => property.isForSale === filters.isForSale
      );
    }

    // Set filtered properties
    setFilteredProperties(filteredData);
  }, [filters, properties]); // Dependencies include filters and the properties data

  return (
    <>
      <button
        onClick={handleSort}
        style={{
          display: "flex",
          flexDirection:"row",
          fontFamily: "Title",
          fontSize: "0.9rem",
          alignItems: "center",
          gap:"3px"
        }}
      >
        Sort{" "}
        {sortOrder === 1 ? (
          <ImSortAlphaAsc style={{ fontSize: "1rem" }} />
        ) : sortOrder === 2 ? (
          <ImSortAlphaDesc style={{ fontSize: "1rem" }} />
        ) : (
          <SortByAlphaIcon style={{ fontSize: "1rem" }} />
        )}
      </button>
      <div className="property-grid">
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => (
            <PropertyCard
              key={property.propertyId}
              property={property}
              onClick={() => handlePropertyClick(property)}
            />
          ))
        ) : (
          <p>No properties found for the selected filters.</p>
        )}
      </div>
    </>
  );
};

export default PropertyList;
